import { styled } from '@mui/system';

const Wrapper = styled('div')({
  color: 'darkslategray',
  backgroundColor: 'aliceblue',
  padding: 8,
  borderRadius: 4,
  borderCollapse: "separate",
  borderSpacing: 0,
  ".MuiTableRow-root":{  
  boxShadow: "0px 5px 10px 2px #dee5e7", 
  // backgroundColor: "#fff"
 
},
".MuiTableRow-root td:nth-child(2)":{  
  borderTopLeftRadius: 20,
    borderBottomLeftRadius: 20,  
 },
".MuiTableRow-root td:last-child":{  
  borderTopRightRadius: 20,
    borderBottomRightRadius: 20,
    marginRight: 20,
    paddingRight: "25px !important"
},
".css-rqglhn-MuiTable-root" : {  
  borderCollapse: "separate",
  borderSpacing: "0 10px"
},
".MuiPaper-root" : {
  backgroundColor: "transparent",
  boxShadow: "none"
},
".MuiTableCell-head" :{
  backgroundColor: "transparent !important",
  boxShadow: "none !important"
},
".MuiTableRow-head" :{
  backgroundColor: "transparent !important",
  boxShadow: "none !important"
},
".MuiTableRow-hover:hover" : {
  backgroundColor: "transparent !important",
  outline: "1px solid #ff6d44",
  color: "#BF2279"
},
".MuiTableRow-hover:hover td" : { 
  color: "#BF2279",
  backgroundColor: "#fff !important",

},
".MuiTableRow-root .MuiBox-root ":{ 
  maxHeight: 35,
  
},
".MuiTableRow-root .MuiBox-root img":{ 
  maxHeight: 26
},
".column-undefined":{
  // maxWidth: 30,
  width:0,
  padding:0
},
".column-undefined button": {
  justifyContent: "flex-start",
  marginLeft: "3px",
 },
".column-undefined a span": {
  borderRight: "1px solid #BF2279"
},
".column-undefined a span svg": {
  marginRight: "3px"
},
".column-logoUrl img": {
  width: "auto",
  maxWidth: 62 
},
".column-position": {
  maxWidth: 50,
  width: 50
},
"tbody .column-position span": {
  paddingLeft:15
},
"th.column-undefined span": {
  paddingLeft: "15px !important"
}
 
 
});


export default Wrapper;